// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__QI2gW"};